import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { goToPage, reportDWH } from '../../EsimUpgradeBlockSlice';
import { goToInstructionsPageAsync } from '../../EsimUpgradeBlockAsyncThunk';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import esimIcon from './images/esim-icon.svg';

const SuccessPage = (props) => {
    useEffect(() => {
        gtag4({ event: 'EsimUpgrade_Step4_SuccessPage', step: '4', action: 'SuccessPage' });
        props.reportDWH({ actionType: 'eSIM Service Purchase', status: 'Completed', messageText: 'Success' });
    }, []);

    const formatSubscriberNo = (phone) => {
        if (!phone || phone.length < 10) return phone || '';
        return `${phone.slice(0, 3)}-${phone.slice(3)}`;
    };

    const handlePageContinue = () => {
        gtag4({ event: 'EsimUpgrade_Step4_SuccessActivateButton', step: '4', action: 'SuccessActivateButton' });
        props.reportDWH({ actionType: 'SuccessScreen', status: 'Ongoing', messageText: 'ActivateESIMButtonClicked' });
        props.goToInstructionsPageAsync();
    };

    const handleAppActivation = () => {
        window.open(props.tinyAppUrl, '_blank');
    };

    return (
        <div className='esim-upgrade-success-page-wrapper'>
            <div className='esim-upgrade-success-page'>
                <div className='info-banner'>
                    הנחיות להפעלת ה-eSIM יישלחו במייל וב-SMS בסיום התהליך
                </div>

                <div className='esim-upgrade-success-page__content'>
                    <div className='hero'>
                        <Image src={esimIcon} alt='' className='hero__icon' />
                        <div className='hero__title'>מעולה, יש לך eSIM חדש!</div>
                    </div>

                    <div className='info-card'>
                        <div className='info-card__header'>
                            <span className='info-card__label'>הפעלת קו eSIM</span>
                            <div className='info-card__phone'>
                                <span className='info-card__phone-number'>{formatSubscriberNo(props.subscriberNo)}</span>
                                <span className='info-card__phone-icon' aria-hidden='true' />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='esim-upgrade-success-page__footer'>
                    <div className='button-wrapper'>
                        {props.isCellcomAppActive ? (
                            <>
                                <BtnSubmit
                                    isBusiness={false}
                                    text='להפעלת ה-eSIM דרך האפליקציה'
                                    onclick={handleAppActivation}
                                    formid='esim-block'
                                    isDisplayArrows={false}
                                    isDisplayWhatsAppIcon={false}
                                />
                                <div className='ml-app-button'>
                                    <a href='#' onClick={(e) => { e.preventDefault(); handlePageContinue(); }}>
                                        להפעלה דרך QR או קודי הפעלה
                                    </a>
                                </div>
                            </>
                        ) : (
                            <BtnSubmit
                                isBusiness={false}
                                text='לתהליך הפעלת ה-eSIM'
                                onclick={handlePageContinue}
                                formid='esim-block'
                                isDisplayArrows={false}
                                isDisplayWhatsAppIcon={false}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        subscriberNo: state.esimUpgradeBlock.loginDetails.subscriberNo,
        instructionsPageUrl: state.esimUpgradeBlock.esimBlockData.instructionsPageUrl,
        isCellcomAppActive: state.esimUpgradeBlock.isCellcomAppActive,
        tinyAppUrl: state.esimUpgradeBlock.tinyAppUrl,
    };
};

const mapDispatchToProps = {
    goToPage,
    reportDWH,
    goToInstructionsPageAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
